import {  getAllGerminatedBatchOptions } from "@/api/germination_batch";

const state = {
    germinationBatchOptions: null
};


const mutations = {
    GET_OPTIONS: (state, data) => {
        state.germinationBatchOptions = data;
    },
};


const actions = {
    async getAllGerminatedBatchOptions({ commit }) {
        let res = await getAllGerminatedBatchOptions();
        if (res) {
            commit("GET_OPTIONS", res); 
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};







// WEBPACK FOOTER //
// ./src/vuex/modules/germination_batch.js